/* ============================================================
   MFL MODERN LAYER — runtime v3 PREMIUM
   Luxuriöser Blumenshop: warm, elegant, viel Bewegung
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------------------------------------------------------
  // 0. Preloader — elegant page entrance
  // ---------------------------------------------------------
  function initPreloader() {
    var loader = document.getElementById('mfl-preloader');
    if (!loader) return;

    function dismiss() {
      loader.classList.add('is-done');
      setTimeout(function () {
        if (loader.parentNode) loader.parentNode.removeChild(loader);
      }, 700);
    }

    // Dismiss on load or after 2.5s max
    if (document.readyState === 'complete') {
      setTimeout(dismiss, 200);
    } else {
      window.addEventListener('load', function () { setTimeout(dismiss, 200); });
      setTimeout(dismiss, 2500);
    }
  }

  // ---------------------------------------------------------
  // 1. Inject chrome elements (progress bar, cursor glow)
  // ---------------------------------------------------------
  function injectChrome() {
    if (!document.getElementById('mfl-progress')) {
      var bar = document.createElement('div');
      bar.id = 'mfl-progress';
      document.body.appendChild(bar);
    }

    // Cursor glow — desktop only
    if (!reduced && window.matchMedia('(hover: hover) and (min-width: 768px)').matches) {
      if (!document.getElementById('mfl-cursor-glow')) {
        var glow = document.createElement('div');
        glow.id = 'mfl-cursor-glow';
        document.body.appendChild(glow);
      }
    }
  }

  // ---------------------------------------------------------
  // 2. Cursor glow follow — subtle ambient light
  // ---------------------------------------------------------
  function initCursorGlow() {
    if (reduced) return;
    var glow = document.getElementById('mfl-cursor-glow');
    if (!glow) return;

    var mx = 0, my = 0, cx = 0, cy = 0;
    var active = false;
    var raf;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX;
      my = e.clientY;
      if (!active) {
        active = true;
        glow.classList.add('is-active');
        tick();
      }
    }, { passive: true });

    document.addEventListener('mouseleave', function () {
      active = false;
      glow.classList.remove('is-active');
      if (raf) cancelAnimationFrame(raf);
    });

    function tick() {
      if (!active) return;
      // Smooth lerp
      cx += (mx - cx) * 0.12;
      cy += (my - cy) * 0.12;
      glow.style.left = cx + 'px';
      glow.style.top = cy + 'px';
      raf = requestAnimationFrame(tick);
    }
  }

  // ---------------------------------------------------------
  // 3. Auto-decorate using REAL Avone selectors
  // ---------------------------------------------------------
  function autoDecorate() {

    // SECTION TITLES
    document.querySelectorAll('.sec-ttl').forEach(function (el) {
      if (el.__mflDone) return;
      el.__mflDone = true;
      el.setAttribute('data-mfl-reveal', 'fade');
      var h = el.querySelector('h2, h3, .title');
      if (h && !h.querySelector('i, img, svg, .mfl-word')) {
        splitToWords(h);
        h.classList.add('mfl-kinetic');
      }
      el.querySelectorAll('.desc, p, .subtitle').forEach(function (p) {
        p.setAttribute('data-mfl-reveal', '');
        p.style.transitionDelay = '0.35s';
      });
    });

    // Index sections — reveal on scroll
    document.querySelectorAll('.shopify-section.index-section').forEach(function (section) {
      if (section.__mflDone) return;
      section.__mflDone = true;
      if (section.querySelector('.slideshow')) return;
      section.setAttribute('data-mfl-reveal', '');
    });

    // Stagger containers
    document.querySelectorAll('.clbox').forEach(function (box) {
      if (box.__mflStagger) return;
      var grid = box.querySelector('.flickity-slider, .grid, .fl, ul.grid-uniform, .products-list') || box;
      if (grid.children.length >= 2) {
        grid.__mflStagger = true;
        grid.setAttribute('data-mfl-stagger', '');
      }
    });

    // Logo list items
    document.querySelectorAll('.logo-list, [class*="logo-list"]').forEach(function (el) {
      var grid = el.querySelector('.grid, .fl, ul') || el;
      if (grid.children.length >= 2 && !grid.__mflStagger) {
        grid.__mflStagger = true;
        grid.setAttribute('data-mfl-stagger', '');
      }
    });

    // Store features grid stagger
    document.querySelectorAll('.store-features').forEach(function (el) {
      var grid = el.querySelector('.grid, .fl, .fl1') || el;
      if (grid.children.length >= 2 && !grid.__mflStagger) {
        grid.__mflStagger = true;
        grid.setAttribute('data-mfl-stagger', '');
      }
    });

    // Parallax on banner images
    document.querySelectorAll(
      '.banner-with-text img, .collections-banners img, .lookbook img, [class*="banner"] .bg-image'
    ).forEach(function (img) {
      if (img.__mflParallax) return;
      img.__mflParallax = true;
      img.setAttribute('data-mfl-parallax', '');
    });

    // Image reveal on collection banners
    document.querySelectorAll('.collections-banners .gitem img, .banner-with-text .gitem img').forEach(function (img) {
      if (img.__mflImgReveal) return;
      img.__mflImgReveal = true;
      img.setAttribute('data-mfl-img-reveal', '');
    });

    // Quotes / testimonial section stagger
    document.querySelectorAll('.quotes .flickity-slider, .quotes .grid, .quotes .fl').forEach(function (grid) {
      if (grid.__mflStagger) return;
      if (grid.children.length >= 2) {
        grid.__mflStagger = true;
        grid.setAttribute('data-mfl-stagger', '');
      }
    });
  }

  function splitToWords(el) {
    var text = el.textContent.trim();
    if (!text) return;
    var words = text.split(/\s+/);
    var html = '';
    for (var i = 0; i < words.length; i++) {
      html += '<span class="mfl-word"><span>' + escapeHtml(words[i]) + '</span></span>';
      if (i < words.length - 1) html += ' ';
    }
    el.innerHTML = html;
  }

  function escapeHtml(s) {
    return s.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---------------------------------------------------------
  // 4. Scroll reveal via IntersectionObserver
  // ---------------------------------------------------------
  var revealIO;
  function initReveal() {
    if (reduced || !('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-mfl-reveal], [data-mfl-stagger], [data-mfl-img-reveal]').forEach(function (el) {
        el.classList.add('is-in');
        Array.prototype.forEach.call(el.children, function (c) { c.classList.add('is-in'); });
      });
      return;
    }

    function markIn(el) {
      el.classList.add('is-in');
      if (el.hasAttribute('data-mfl-stagger')) {
        Array.prototype.forEach.call(el.children, function (c) { c.classList.add('is-in'); });
      }
      // Kinetic spans
      el.querySelectorAll('.mfl-kinetic').forEach(function (k) {
        k.classList.add('is-in');
        k.querySelectorAll('.mfl-word > span').forEach(function (s, idx) {
          setTimeout(function () {
            s.style.setProperty('transition', 'none', 'important');
            s.style.setProperty('transform', 'translateY(0)', 'important');
            requestAnimationFrame(function () {
              s.style.removeProperty('transition');
            });
          }, idx * 70);
        });
      });
    }

    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            markIn(entry.target);
            revealIO.unobserve(entry.target);
          }
        });
      }, { threshold: 0.01, rootMargin: '0px 0px 6% 0px' });
    }

    var vh = window.innerHeight;
    document.querySelectorAll('[data-mfl-reveal]:not(.is-in), [data-mfl-stagger]:not(.is-in), [data-mfl-img-reveal]:not(.is-in), [data-mfl-line]:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) {
        markIn(el);
      } else {
        revealIO.observe(el);
      }
    });

    // Failsafe: nichts darf dauerhaft unsichtbar bleiben (verpasste IO-Trigger,
    // spaeterer JS-Fehler). Stufe 1 (2.5s): nur was bereits im/ueber dem Viewport
    // liegt. Stufe 2 (8s): alles Verbliebene — Sicherheitsnetz statt Effekt.
    function forceReveal(inViewportOnly) {
      document.querySelectorAll('[data-mfl-reveal]:not(.is-in), [data-mfl-stagger]:not(.is-in)').forEach(function (el) {
        if (inViewportOnly && el.getBoundingClientRect().top >= window.innerHeight) return;
        markIn(el);
        if (revealIO) revealIO.unobserve(el);
      });
    }
    setTimeout(function () { forceReveal(true); }, 2500);
    setTimeout(function () { forceReveal(false); }, 8000);
  }

  // ---------------------------------------------------------
  // 5. Header scroll behavior — shrink + hide/show
  // ---------------------------------------------------------
  function setHeaderHeightVar() {
    var h = document.getElementById('header');
    if (!h) return;
    var height = Math.round(h.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--mfl-header-h', height + 'px');
  }

  function initHeader() {
    var body = document.body;
    var lastY = getScrollY();
    var ticking = false;
    var hideThreshold = 400;
    var deadZone = 14;
    setHeaderHeightVar();
    window.addEventListener('resize', setHeaderHeightVar, { passive: true });

    function getScrollY() {
      return window.pageYOffset ||
             document.documentElement.scrollTop ||
             document.body.scrollTop || 0;
    }

    function update() {
      var y = getScrollY();
      var dy = y - lastY;
      if (y > 8) body.classList.add('mfl-header-scrolled');
      else       body.classList.remove('mfl-header-scrolled');
      // Hide-on-scroll disabled — nav should always be visible
      body.classList.remove('mfl-header-hidden');
      lastY = y;
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // ---------------------------------------------------------
  // 6. Scroll progress bar
  // ---------------------------------------------------------
  function initProgress() {
    var bar = document.getElementById('mfl-progress');
    if (!bar) return;
    var ticking = false;
    function getScrollY() {
      return window.pageYOffset ||
             document.documentElement.scrollTop ||
             document.body.scrollTop || 0;
    }
    function update() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var pct = max > 0 ? (getScrollY() / max) * 100 : 0;
      bar.style.setProperty('--mfl-scroll', pct.toFixed(1) + '%');
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // ---------------------------------------------------------
  // 7. Parallax
  // ---------------------------------------------------------
  function initParallax() {
    if (reduced) return;
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-mfl-parallax]'));
    if (!items.length) return;

    var vh = window.innerHeight;
    window.addEventListener('resize', function () { vh = window.innerHeight; }, { passive: true });

    var ticking = false;
    function tick() {
      items.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > vh + 100) return;
        var center = rect.top + rect.height / 2;
        var distance = (center - vh / 2) / vh;
        var translate = Math.max(-40, Math.min(40, distance * -30));
        el.style.transform = 'translate3d(0,' + translate.toFixed(1) + 'px,0) scale(1.03)';
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(tick);
        ticking = true;
      }
    }, { passive: true });
    tick();
  }

  // ---------------------------------------------------------
  // 8. Magnetic primary CTAs (desktop only)
  // ---------------------------------------------------------
  function initMagnetic() {
    if (reduced) return;
    if (window.matchMedia('(hover: none)').matches) return;
    var sel = '.btn-primary, .btn.add-to-cart, .pr_btn, .checkout, [data-mfl-magnetic]';
    document.querySelectorAll(sel).forEach(function (btn) {
      if (btn.__mflMag) return;
      btn.__mflMag = true;
      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var mx = e.clientX - rect.left - rect.width / 2;
        var my = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = 'translate(' + (mx * 0.15).toFixed(1) + 'px,' + (my * 0.18).toFixed(1) + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }

  // ---------------------------------------------------------
  // 9. Number counter animation
  // ---------------------------------------------------------
  function initCounters() {
    if (reduced) return;
    var counters = document.querySelectorAll('[data-mfl-counter]');
    if (!counters.length) return;

    var counterIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        counterIO.unobserve(entry.target);
        animateCounter(entry.target);
      });
    }, { threshold: 0.3 });

    counters.forEach(function (el) { counterIO.observe(el); });

    function animateCounter(el) {
      var target = parseFloat(el.getAttribute('data-mfl-counter')) || 0;
      var suffix = el.getAttribute('data-mfl-suffix') || '';
      var prefix = el.getAttribute('data-mfl-prefix') || '';
      var duration = 2000;
      var start = performance.now();

      function step(now) {
        var elapsed = now - start;
        var progress = Math.min(elapsed / duration, 1);
        // Ease out quad
        var eased = 1 - (1 - progress) * (1 - progress);
        var current = Math.round(target * eased);
        el.textContent = prefix + current.toLocaleString('de-DE') + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
  }

  // ---------------------------------------------------------
  // 10. Smooth scroll for anchor links
  // ---------------------------------------------------------
  function initSmoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var hash = a.getAttribute('href');
        if (!hash || hash === '#') return;
        var target = document.querySelector(hash);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.pushState(null, '', hash);
      });
    });
  }

  // ---------------------------------------------------------
  // 11. Tilt effect on product cards (desktop, subtle)
  // ---------------------------------------------------------
  function initCardTilt() {
    if (reduced) return;
    if (window.matchMedia('(hover: none)').matches) return;

    document.querySelectorAll('.grid-view-item').forEach(function (card) {
      if (card.__mflTilt) return;
      card.__mflTilt = true;

      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'translateY(-8px) perspective(800px) rotateX(' + (y * -3).toFixed(1) + 'deg) rotateY(' + (x * 3).toFixed(1) + 'deg)';
      });

      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  // ---------------------------------------------------------
  // INIT
  // ---------------------------------------------------------
  function init() {
    try { initPreloader(); }      catch (e) { console.warn('mfl preloader', e); }
    try { injectChrome(); }       catch (e) { console.warn('mfl chrome', e); }
    try { autoDecorate(); }       catch (e) { console.warn('mfl decorate', e); }
    try { initReveal(); }         catch (e) { console.warn('mfl reveal', e); }
    try { initHeader(); }         catch (e) { console.warn('mfl header', e); }
    try { initProgress(); }       catch (e) { console.warn('mfl progress', e); }
    try { initParallax(); }       catch (e) { console.warn('mfl parallax', e); }
    try { initMagnetic(); }       catch (e) { console.warn('mfl magnetic', e); }
    try { initCursorGlow(); }     catch (e) { console.warn('mfl cursor', e); }
    try { initCounters(); }       catch (e) { console.warn('mfl counters', e); }
    try { initSmoothAnchors(); }  catch (e) { console.warn('mfl anchors', e); }
    try { initCardTilt(); }       catch (e) { console.warn('mfl tilt', e); }

    window.__mflStatus = {
      ready: true,
      version: 3,
      secTtlDecorated: document.querySelectorAll('.sec-ttl[data-mfl-reveal]').length,
      kinetic: document.querySelectorAll('.mfl-kinetic').length,
      revealTotal: document.querySelectorAll('[data-mfl-reveal]').length,
      stagger: document.querySelectorAll('[data-mfl-stagger]').length,
      imgReveal: document.querySelectorAll('[data-mfl-img-reveal]').length,
      counters: document.querySelectorAll('[data-mfl-counter]').length,
      progressBar: !!document.getElementById('mfl-progress'),
      cursorGlow: !!document.getElementById('mfl-cursor-glow')
    };
    console.info('[MFL] Premium layer v3 active', window.__mflStatus);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () {
      try { autoDecorate(); initReveal(); initMagnetic(); initCardTilt(); } catch (e) {}
    }, 50);
  });
})();

/* ============================================================
   == NEW COMPONENTS RUNTIME v3.1 ==
   ============================================================ */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------------------------------------------------------
  // Order-Steps section — reveal when scrolled into view
  // ---------------------------------------------------------
  function initStepsReveal() {
    var steps = document.querySelectorAll('.mfl-steps');
    if (!steps.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      steps.forEach(function (s) { s.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    steps.forEach(function (s) { io.observe(s); });
  }

  // ---------------------------------------------------------
  // Accordion — FAQ / Care Tips
  // ---------------------------------------------------------
  function initAccordion() {
    document.querySelectorAll('.mfl-acc-item__btn').forEach(function (btn) {
      if (btn.__mflAcc) return;
      btn.__mflAcc = true;
      btn.addEventListener('click', function () {
        var item = btn.closest('.mfl-acc-item');
        if (!item) return;
        item.classList.toggle('is-open');
      });
    });
  }

  // ---------------------------------------------------------
  // Countdown to 21:00 München (Europe/Berlin)
  // ---------------------------------------------------------
  function initUrgencyCountdown() {
    var timer = document.querySelector('[data-mfl-countdown]');
    if (!timer) return;

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function getBerlinNow() {
      // Create a Date in Berlin timezone via Intl
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Berlin',
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric',
        hour12: false
      });
      var parts = {};
      fmt.formatToParts(new Date()).forEach(function (p) {
        if (p.type !== 'literal') parts[p.type] = parseInt(p.value, 10);
      });
      // Hour can be 24 for midnight, fix it
      if (parts.hour === 24) parts.hour = 0;
      return parts;
    }

    function update() {
      var now = getBerlinNow();
      var secondsToday = now.hour * 3600 + now.minute * 60 + now.second;
      var cutoff = 21 * 3600; // 21:00
      var remaining = cutoff - secondsToday;

      // Chip is the parent span containing prefix + timer + suffix
      var chip = timer.closest('.mfl-tb-chip');
      var msgLate = timer.getAttribute('data-late-msg');

      if (remaining <= 0) {
        // After 21:00 — replace the entire chip content with the late message
        if (chip && msgLate && !chip.__mflLate) {
          chip.textContent = msgLate;
          chip.__mflLate = true;
        }
        return;
      }

      var h = Math.floor(remaining / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      var s = remaining % 60;
      timer.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }

    update();
    setInterval(update, 1000);
  }

  // ---------------------------------------------------------
  // Marquee — duplicate content for seamless loop
  // ---------------------------------------------------------
  function initMarquee() {
    document.querySelectorAll('.mfl-marquee').forEach(function (m) {
      if (m.__mflDup) return;
      m.__mflDup = true;
      // Clone every direct child once so the loop is seamless
      var kids = Array.prototype.slice.call(m.children);
      kids.forEach(function (k) {
        var clone = k.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        m.appendChild(clone);
      });
    });
  }

  // ---------------------------------------------------------
  // Init on DOM ready
  // ---------------------------------------------------------
  function initNew() {
    try { initStepsReveal(); }      catch (e) { console.warn('mfl steps', e); }
    try { initAccordion(); }        catch (e) { console.warn('mfl accordion', e); }
    try { initUrgencyCountdown(); } catch (e) { console.warn('mfl countdown', e); }
    try { initMarquee(); }          catch (e) { console.warn('mfl marquee', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNew);
  } else {
    initNew();
  }
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initNew, 50);
  });
})();

/* ============================================================
   == v3.2 — Relocate homepage sections into content flow ==
   ============================================================ */
(function () {
  'use strict';
  function relocate() {
    // Find main container that holds all shopify-sections
    var main = document.querySelector('#PageContainer, .main-content, main');
    if (!main) return;

    // 1. How-it-works → right after the first slideshow (or first section)
    var how = document.querySelector('.mfl-how');
    var firstHero = document.querySelector(
      '#shopify-section-slideshow, .shopify-section .slideshow'
    );
    if (how && firstHero) {
      var heroSection = firstHero.closest('.shopify-section') || firstHero;
      if (heroSection.parentNode) {
        heroSection.parentNode.insertBefore(how, heroSection.nextSibling);
      }
    }

    // 2. Collect the remaining premium sections in the order we want them to appear
    //    near the end of the page (after products / collections, before logo list).
    var why = document.querySelector('.mfl-why');
    var stats = document.querySelector('.mfl-stats');
    var marq = document.querySelector('.mfl-reviews-marquee');

    // Find an anchor — the logo-list section (near the bottom), or fallback: footer
    var logoList = document.querySelector('.shopify-section .logo-list, [id*="logo_list"]');
    var anchor = logoList ? logoList.closest('.shopify-section') : null;

    var blocks = [why, stats, marq].filter(Boolean);
    blocks.forEach(function (el) {
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(el, anchor);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocate);
  } else {
    relocate();
  }
})();

/* ============================================================
   == v3.3 — Countdown pill injected into existing top-info-bar ==
   ============================================================ */
(function () {
  'use strict';
  function injectTopbarCountdown() {
    // Only on index page
    if (!document.body.classList.contains('template-index') && !document.body.classList.contains('index')) {
      // heuristic: try to inject anywhere so chip also shows on other pages — keep commented for now
    }
    var bars = document.querySelectorAll('.top-info-bar');
    if (!bars.length) return;
    bars.forEach(function (bar) {
      if (bar.__mflCountdownInjected) return;
      bar.__mflCountdownInjected = true;
      var wrap = document.createElement('div');
      wrap.className = 'fl1 tc-md';
      wrap.innerHTML = '<span class="mfl-tb-chip">Lieferung morgen · noch <span class="mfl-tb-timer" data-mfl-countdown data-late-msg="Bestellannahme für morgen geschlossen">--:--:--</span></span>';
      bar.appendChild(wrap);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectTopbarCountdown);
  } else {
    injectTopbarCountdown();
  }
})();

/* Topbar-Slide-Rotation. Slide 1 tagesabhaengig: Samstag ab 06:00 Muenchner Zeit
   gilt "morgen geliefert" nicht (Sonntagssperre) — dann Montag-Variante zeigen. */
(function () {
  var box = document.getElementById('mflTbSlides');
  if (!box) return;
  var slides = box.querySelectorAll('.mfl-tbslide');
  if (!slides.length) return;

  var del = box.querySelector('[data-mfl-slide="delivery"]');
  if (del) {
    try {
      var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));

      // Naechsten Liefertag nach denselben Regeln wie Warenkorb-Kalender und
      // Lieferversprechen bestimmen: vor 06:00 zaehlt der laufende Tag, ab 06:00
      // der naechste; Sonntag nur bei Bestellung vor Samstag 06:00; Feiertage
      // brauchen die Bestellung ebenfalls einen Werktag vorher bis 06:00.
      // Ohne die Feiertage haette die Leiste z. B. "Lieferung am Montag"
      // behauptet, wenn der Montag ein Feiertag ist.
      var day = window.MFL_HOLIDAYS_BY && window.MFL_HOLIDAYS_BY.nextDeliveryDay(now);
      if (!day) throw new Error('Feiertagsmodul nicht geladen');

      var today0 = new Date(now); today0.setHours(0, 0, 0, 0);
      var diff = Math.round((day - today0) / 86400000);
      var tplToday = del.getAttribute('data-txt-today');
      var tplNext  = del.getAttribute('data-txt-next');

      if (diff === 0 && tplToday) {
        del.textContent = tplToday;
      } else if (tplNext) {
        var label;
        if (diff === 1) {
          label = del.getAttribute('data-day-tomorrow');
        } else {
          var wd = new Intl.DateTimeFormat(document.documentElement.lang || 'de', { weekday: 'long' }).format(day);
          label = (del.getAttribute('data-day-named') || '[weekday]').replace('[weekday]', wd);
        }
        del.textContent = tplNext.replace('[day]', label);
      } else if (now.getDay() === 0 || (now.getDay() === 6 && now.getHours() >= 6)) {
        del.textContent = del.getAttribute('data-txt-sat');   // Fallback: alte Variante
      }
    } catch (e) { /* Fallback: Default-Text bleibt */ }
  }

  if (slides.length < 2) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var i = 0;
  setInterval(function () {
    slides[i].classList.remove('is-on');
    i = (i + 1) % slides.length;
    slides[i].classList.add('is-on');
  }, 5000);
})();

/* PDP: Preise auf den Groessen-Buttons folgen der aktuell gewaehlten Farbe.
   Grund: Bei einigen Produkten (z.B. lavender-spray) kostet dieselbe Groesse
   je nach Farbe unterschiedlich viel — statische Button-Preise waeren falsch. */
(function () {
  function money(cents) {
    if (cents % 100 === 0) return (cents / 100) + ' €';
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function init() {
    if (!document.querySelector('.swatchLbl.has-price')) return;
    var jsonEl = document.querySelector('[id^="ProductJson-"]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!product || !product.variants) return;

    var swatchGroups = Array.prototype.slice.call(document.querySelectorAll('.swatch[data-option-index]'));

    function selectedValues() {
      return swatchGroups.map(function (sw) {
        var c = sw.querySelector('.swatchInput:checked');
        return c ? c.value : null;
      });
    }

    function update() {
      var sels = selectedValues();
      swatchGroups.forEach(function (sw) {
        var idx = parseInt(sw.getAttribute('data-option-index'), 10);
        sw.querySelectorAll('.swatchLbl.has-price').forEach(function (lbl) {
          var input = document.getElementById(lbl.getAttribute('for'));
          if (!input) return;
          var want = sels.slice();
          want[idx] = input.value;
          var match = null;
          for (var i = 0; i < product.variants.length; i++) {
            var v = product.variants[i];
            var ok = true;
            for (var j = 0; j < want.length; j++) {
              if (want[j] != null && v.options[j] !== want[j]) { ok = false; break; }
            }
            if (ok) { match = v; break; }
          }
          if (!match) {
            for (var k = 0; k < product.variants.length; k++) {
              if (product.variants[k].options[idx] === input.value) { match = product.variants[k]; break; }
            }
          }
          var pr = lbl.querySelector('.swatchPrice');
          if (match && pr) pr.textContent = money(match.price);
        });
      });
    }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('swatchInput')) update();
    });
    update();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Sprachwahl: aktive Flagge oeffnet das Dropdown.
   Schliesst bei Klick ausserhalb und mit Escape. */
(function () {
  var box = document.getElementById('mflLangs');
  if (!box) return;
  var toggle = box.querySelector('.mfl-lang-toggle');
  if (!toggle) return;

  function close() {
    box.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  }
  function open() {
    box.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
  }

  toggle.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (box.classList.contains('is-open')) close(); else open();
  });

  document.addEventListener('click', function (e) {
    if (!box.contains(e.target)) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) close();
  });
})();
